import apiClient from "../api/apiClient";
import { TICKETS_API } from "../api/consts";
export interface TicketParams {
  eventId: number;
  token: string;
}
export const getTicketPDF = async ({ eventId, token }: TicketParams) => {
  console.log("getTicketPDF1", `${TICKETS_API}/${eventId}/${token}`);
    try {
      const res: any = await apiClient.get(`${TICKETS_API}/${eventId}/${token}`, {
        responseType: "arraybuffer",
      });

      console.log("getTicketPDF2 res", res);
  
      if (res.status !== 200) return null;
      return res.data;
    } catch (error: any) {
      console.error("Failed to fetch ticket PDF", error);
      return null;
    }
};